var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iconography-content"},[_c('div',{staticClass:"iconography-banner-image",style:({ backgroundImage: `url(${_vm.iconographyBannerImageSrc})` })}),_c('div',{staticClass:"iconography-overlay-image"},[_c('h1',{staticClass:"iconography-banner-title"},[_vm._v(_vm._s(_vm.iconographyBannerImageTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }